const OAUTH_BASED_PROVIDERS = new Set(['googleanalytics', 'yandexmetrika', 'appmetrica']);
const CREDENTIAL_BASED_PROVIDERS = new Set(['comagic']);
const CREDENTIALS_SECRET_KEY_BASED_PROVIDERS = new Set(['amocrm']);

export default function fillChannelsWithConnectionMethod (providers) {
  return providers.map(channel => {
    const connectionMethods = new Set([]);
    const channelName = channel.name;

    // store.getters.canUser('CREATE_WEB_ANALYTICS_OAUTH_CONNECTION') TODO: think about it
    if (OAUTH_BASED_PROVIDERS.has(channelName)) {
      connectionMethods.add('OAUTH');
    }
    if (CREDENTIAL_BASED_PROVIDERS.has(channelName)) {
      connectionMethods.add('CREDENTIALS');
    }
    if (CREDENTIALS_SECRET_KEY_BASED_PROVIDERS.has(channelName)) {
      connectionMethods.add('SECRET_KEY');
    }

    return {
      ...channel,
      connection_methods: connectionMethods
    };
  });
}
